import Cookies from 'js-cookie';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import User from "../pages/users/User";
import UserDetails from "../pages/users/userDetail/Details";
import Login from "../pages/auth/login/Login";
import { useEffect, useState } from 'react';
import LandingPage from '../pages/landingPage/Index';
import DashBoard from '../pages/dashboard/Dashboard';
import Themes from '../pages/theme/Theme';
import EditThemes from '../pages/theme/editTheme/EditTheme';
import CreateTheme from '../pages/theme/createTheme/CreateTheme';
import Setting from '../pages/settings/Setting';
import Level from '../pages/levels/Level';
import Agency from '../pages/agency/Agency';
import EditLevel from '../pages/levels/editLevel/EditLevel';
import CreateLevel from '../pages/levels/createLevel/CreateLevel';
import CreateAgency from '../pages/agency/createAgency/createAgency';
import { getRoleAndToken, getToken } from '../utility/sessionStorage';
import EditAgency from '../pages/agency/editAgency/EditAgency';
import DetailAgency from '../pages/agency/agencyDetails/Details';
import MasterClass from '../pages/masterClass/MasterClass';
import CreateMasterClass from '../pages/masterClass/createMasterClass/CreateMasterClass';
import EditMasterClass from '../pages/masterClass/editMasterClass/EditMasterClass';
import Module from '../pages/module/Module';
import CreateModule from '../pages/module/createModule/CreateModule';
import EditModule from '../pages/module/editModule/EditModule';
import EditInformation from '../pages/information/editInformation/EditInformation';
import Information from '../pages/information/Information';
import CustomPages from '../pages/customPage/CustomPage';
import EditCustomPage from '../pages/customPage/edit/Edit';
import CreateMatchStyle from '../pages/matchStyle/createMatchStyle/Create';
import EditMatchStyle from '../pages/matchStyle/editMatchStyle/Edit';
import MatchStyle from '../pages/matchStyle/MatchStyle';
import Match from '../pages/match/Match';
import MatchLimit from '../pages/matchLimit/MatchLimit';
import MatchLimitEdit from '../pages/matchLimit/editMatchLimit/Edit';
import Password from '../pages/changePassword/Password';
import Subscription from '../pages/subscriptions/Subscription';
import EditSubscription from '../pages/subscriptions/edit/Edit';
import AgencyLogin from '../pages/agencyAdmin/auth/login/Login';
import AgencyLandingPage from '../pages/agencyAdmin/landingPage/Index';
import AgencyDashboard from '../pages/agencyAdmin/dashboard/Dashboard';
import AgencyPassword from '../pages/agencyAdmin/changePassword/Password';
import AgencyProfileUpdate from '../pages/agencyAdmin/settings/UpdateProfile';
import Agent from '../pages/agencyAdmin/agents/Agent';
import CreateAgent from '../pages/agencyAdmin/agents/createAgent/createAgent';
import EditAgent from '../pages/agencyAdmin/agents/editAgent/EditAgent';
import ImportUsers from '../pages/agencyAdmin/importUsers/importUsers';
import AgencyUsers from '../pages/agencyAdmin/users/Users';
import AgencyMatch from '../pages/agencyAdmin/match/Match';
import AgentLogin from '../pages/agentAdmin/auth/login/Login';
import AgentLandingPage from '../pages/agentAdmin/landingPage/Index';
import AgentDashboard from '../pages/agentAdmin/dashboard/Dashboard';
import AgentPassword from '../pages/agentAdmin/changePassword/Password';
import AgentProfileUpdate from '../pages/agentAdmin/settings/UpdateProfile';
import AgentImportUsers from '../pages/agentAdmin/importUsers/importUsers';
import AgentUsers from '../pages/agentAdmin/users/Users';
import AgentMatch from '../pages/agentAdmin/match/Match';
import CreateMatch from '../pages/agencyAdmin/matchOffers/create/Create';
import MatchOffer from '../pages/agencyAdmin/matchOffers/MatchOffer';
import CreateMatchAgent from '../pages/agentAdmin/matchOffers/create/Create';
import MatchOfferAgent from '../pages/agentAdmin/matchOffers/MatchOffer';
import Notification from '../pages/notifications/Notification';
import CreateNotification from '../pages/notifications/createNotification/CreateNotification';
import Performance from '../pages/agencyAdmin/performance/performance';
import Bonus from '../pages/agencyAdmin/bonus/Bonus';
import Beginner from '../pages/agencyAdmin/bonus/beginners/Beginner';
import Advanced from '../pages/agencyAdmin/bonus/advanced/Advanced';
import AgentPerformance from '../pages/agentAdmin/performance/performance';
import TypeOfMonths from '../pages/agencyAdmin/bonus/typesOfMonths/TypeOfMonths';
import BonusList from '../pages/agencyAdmin/bonus/bonusList/BonusList';
function RootRoutes() {

    const [token, setToken] = useState(getToken());
    const [role, setRole] = useState(getRoleAndToken()?.role);
    useEffect(() => {
        // const cookieToken = Cookies.get('token');
        const cookieToken = getToken();
        const { role } = getRoleAndToken();
        setToken(cookieToken)
        setRole(role)
        window.addEventListener('update-token', handleUpdateToken);

        return () => {
            window.removeEventListener('update-token', handleUpdateToken);
        };
    }, []);

    const handleUpdateToken = () => {
        // const cookieToken = Cookies.get('token');
        const cookieToken = getToken()
        const { role } = getRoleAndToken();
        setRole(role)
        setToken(cookieToken)
    }

    return (
        <BrowserRouter>
            <Routes

            >
                <Route path="*" element={<div > 404 </div>} />
                <Route element={<Login />} path="login" />
                <Route element={token && role === "agency" ? <AgencyLandingPage /> : <AgencyLogin />} path="/agency" >
                    <Route element={<AgencyLogin />} path="login" />
                    <Route element={<AgencyDashboard />} path="dashboard" />
                    <Route element={< AgencyPassword />} path="change-password" />
                    <Route element={< AgencyProfileUpdate />} path="profile-update" />
                    <Route element={< Agent />} path="agents" />
                    <Route element={< CreateAgent />} path="agents/create" />
                    <Route element={< EditAgent />} path="agents/:id/edit" />
                    <Route element={< ImportUsers />} path="imported-users" />
                    <Route element={< AgencyUsers />} path="fame-users" />
                    <Route element={< AgencyMatch />} path="confirmed-matches" />
                    <Route element={< CreateMatch />} path="match-offers/create" />
                    <Route element={< MatchOffer />} path="match-offers" />
                    <Route element={< Performance />} path="performance" />
                    <Route element={< Bonus />} path="bonus" />
                    <Route element={< Beginner />} path="bonus/beginners" />
                    <Route element={< Advanced />} path="bonus/advanced" />
                    <Route element={< TypeOfMonths />} path="bonus/types-of-months" />
                    <Route element={< BonusList />} path="bonuses" />
                </Route>

                <Route element={token && role === "agent" ? <AgentLandingPage /> : <AgentLogin />} path="/agent" >
                    <Route element={<AgentLogin />} path="login" />
                    <Route element={<AgentDashboard />} path="dashboard" />
                    <Route element={< AgentPassword />} path="change-password" />
                    <Route element={< AgentProfileUpdate />} path="profile-update" />
                    <Route element={< AgentImportUsers />} path="imported-users" />
                    <Route element={< AgentUsers />} path="fame-users" />
                    <Route element={< AgentMatch />} path="confirmed-matches" />
                    <Route element={< CreateMatchAgent />} path="match-offers/create" />
                    <Route element={< MatchOfferAgent />} path="match-offers" />
                    <Route element={<AgentPerformance />} path="performance" />
                </Route>

                <Route element={!!token && role === "admin" ? <LandingPage /> : <Login />} path="/">

                    <Route element={<DashBoard />} path="dashboard" />

                    <Route element={<User />} path="user" />
                    <Route element={<UserDetails />} path="user/:id/details" />
                    <Route element={<User />} path="user" />

                    <Route element={<Themes />} path="themes" />
                    <Route element={<EditThemes />} path="themes/:id/edit" />
                    <Route element={<CreateTheme />} path="themes/create" />

                    <Route element={<Setting />} path="settings" />

                    <Route element={<Level />} path="levels" />
                    <Route element={<EditLevel />} path="levels/:id/edit" />
                    <Route element={<CreateLevel />} path="levels/create" />

                    <Route element={<Agency />} path="agencies" />
                    <Route element={<CreateAgency />} path="agencies/create" />
                    <Route element={<EditAgency />} path="agencies/:id/edit" />
                    <Route element={<DetailAgency />} path="agencies/:code/show" />

                    <Route element={<MasterClass />} path="module/:moduleId/masterClass/:name" />
                    <Route element={<CreateMasterClass />} path="module/:moduleId/masterClass/:name/create" />
                    <Route element={<EditMasterClass />} path="module/:moduleId/masterClass/:id/edit" />

                    <Route element={<Module />} path="module" />
                    <Route element={<CreateModule />} path="module/create" />
                    <Route element={<EditModule />} path="module/:id/edit" />

                    <Route element={<Information />} path="information" />
                    <Route element={<EditInformation />} path="information/:id/edit" />

                    <Route element={<CustomPages />} path="customPages" />
                    <Route element={<EditCustomPage />} path="customPages/:id/edit" />

                    <Route element={<MatchStyle />} path="matchStyle" />
                    <Route element={<CreateMatchStyle />} path="matchStyle/create" />
                    <Route element={<EditMatchStyle />} path="matchStyle/:id/edit" />

                    <Route element={<Match />} path="confirmed-matches" />

                    <Route element={<MatchLimit />} path="match-limits" />
                    <Route element={<MatchLimitEdit />} path="match-limit/:id/edit" />

                    <Route element={<Subscription />} path="subscriptions" />
                    <Route element={<EditSubscription />} path="subscriptions/:id/edit" />

                    <Route element={<Password />} path="change-password" />
                    <Route element={<Notification />} path="notifications" />
                    <Route element={<CreateNotification />} path="notifications/create" />
                </Route>
            </Routes>
        </BrowserRouter >
    )
}

export default RootRoutes
